import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { PURGE } from 'redux-persist';
import { MenuList } from '../types/main';

interface MainState {
  isListChanged: boolean;
  notifications: [];
  modals: {
    name: string;
    hasOpened: boolean;
  }[];
  menuList: MenuList;
}

const initialState: MainState = {
  isListChanged: false,
  notifications: [],
  modals: [
    {
      name: 'exceededStorage',
      hasOpened: false,
    },
  ],
  menuList: [],
};

export const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setIsListChanged: (state, action) => {
      state.isListChanged = action.payload;
    },
    notificationsChanged: (state, { payload }) => {
      state.notifications = payload;
    },
    modalHasOpenedChanged: (state, { payload }) => {
      const idx = state.modals.findIndex(({ name }) => name === payload.name);
      state.modals[idx].hasOpened = payload.hasOpened;
    },
    menuListAdded: (state, { payload }) => {
      state.menuList = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const {
  setIsListChanged,
  notificationsChanged,
  modalHasOpenedChanged,
  menuListAdded,
} = mainSlice.actions;

export const selectIsMainListChanged = (state: RootState) =>
  state.main.isListChanged;

export const selectNotifications = (state: RootState) =>
  state.main.notifications;

export const selectModals = (state: RootState) => state.main.modals;
export const selectMenuList = (state: RootState) => state.main.menuList;

export default mainSlice.reducer;
